import { render, staticRenderFns } from "./DataInfo.vue?vue&type=template&id=1c7e321a&scoped=true"
import script from "./DataInfo.vue?vue&type=script&lang=js"
export * from "./DataInfo.vue?vue&type=script&lang=js"
import style0 from "./DataInfo.vue?vue&type=style&index=0&id=1c7e321a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e321a",
  null
  
)

export default component.exports